/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../common";
import type {
  MoarLocker,
  MoarLockerInterface,
} from "../../../../../../contracts/submodules/moar-locker/contracts/moar/MoarLocker";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "nft",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorizations",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "authorization",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "authorize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "moar",
    outputs: [
      {
        internalType: "contract Moar",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarLockerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarLockerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarLocker__factory extends ContractFactory {
  constructor(...args: MoarLockerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    nft: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MoarLocker> {
    return super.deploy(nft, overrides || {}) as Promise<MoarLocker>;
  }
  override getDeployTransaction(
    nft: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(nft, overrides || {});
  }
  override attach(address: string): MoarLocker {
    return super.attach(address) as MoarLocker;
  }
  override connect(signer: Signer): MoarLocker__factory {
    return super.connect(signer) as MoarLocker__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarLockerInterface {
    return new utils.Interface(_abi) as MoarLockerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarLocker {
    return new Contract(address, _abi, signerOrProvider) as MoarLocker;
  }
}
